import useTestId from '@ori/testid-generator';
import { CAROUSEL_SLIDE } from '../../common';
import { SLIDE_CLASSNAME } from './constants';
import { CarouselSlideRoot } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const CarouselSlide = ({
  children,
  minWidth,
  style,
  testId
}) => {
  const {
    getTestId
  } = useTestId();
  return /*#__PURE__*/_jsx(CarouselSlideRoot, {
    className: SLIDE_CLASSNAME,
    "data-testid": testId ?? getTestId(CAROUSEL_SLIDE),
    minWidth: minWidth,
    style: style,
    children: children
  });
};
//# sourceMappingURL=CarouselSlide.js.map